import useLocales from 'hooks/useLocales';
import React, { FC } from 'react';

export const ActivateAccount: FC = (): JSX.Element => {
  const { t } = useLocales();
  return <h1>{t('Please activate account')}</h1>;
};
